// Force desktop menu to work on hover only (no click)
document.addEventListener('DOMContentLoaded', function() {
  // Only run on desktop
  if (window.innerWidth >= 990) {
    const headerMenus = document.querySelectorAll('header-menu');

    headerMenus.forEach(menu => {
      const details = menu.querySelector('details');
      const summary = menu.querySelector('summary');

      if (details && summary) {
        // Prevent click/toggle behavior
        summary.addEventListener('click', function(e) {
          e.preventDefault();
          return false;
        });

        // Force details to be open so submenu is in DOM
        details.setAttribute('open', '');

        // Prevent keyboard toggle
        details.addEventListener('toggle', function(e) {
          e.preventDefault();
          if (!details.hasAttribute('open')) {
            details.setAttribute('open', '');
          }
        });
      }
    });
  }
});

// Re-run on resize if switching to desktop
let resizeTimer;
window.addEventListener('resize', function() {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function() {
    if (window.innerWidth >= 990) {
      const headerMenus = document.querySelectorAll('header-menu');
      headerMenus.forEach(menu => {
        const details = menu.querySelector('details');
        if (details) {
          details.setAttribute('open', '');
        }
      });
    }
  }, 250);
});
